<div id="dept-commerce" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Department of Commerce & Management</h2>
    <p class="inner-lead mt-3">
      The Department of Commerce & Management at Shah Satnam Ji Girls' College, Sirsa provides comprehensive education in business, finance and management. With experienced faculty and industry-relevant curriculum, the department prepares students for careers in commerce, banking, finance and entrepreneurship.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Courses Offered</h4>
    <div class="table-responsive-inner mt-3">
      <table class="inner-table">
        <thead><tr><th>Level</th><th>Programme</th></tr></thead>
        <tbody>
          <tr><td>UG</td><td>B.Com (General)</td></tr>
          <tr><td>UG</td><td>B.Com (Vocational)</td></tr>
          <tr><td>UG</td><td>Bachelor of Business Administration (BBA)</td></tr>
          <tr><td>PG</td><td>M.Com (Finance)</td></tr>
        </tbody>
      </table>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Faculty</h4>
    <div class="table-responsive-inner mt-3">
      <table class="inner-table">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Qualification</th>
            <th>Designation</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>1</td><td>Ms. Tulsi</td><td>M.Com, UGC NET</td><td>HOD</td></tr>
          <tr><td>2</td><td>Ms. Leenu</td><td>MBA, M.Com</td><td>Assistant Professor</td></tr>
          <tr><td>3</td><td>Ms. Neha</td><td>MBA, M.Com</td><td>Assistant Professor</td></tr>
          <tr><td>4</td><td>Ms. Yogita</td><td>MBA, M.Com</td><td>Assistant Professor</td></tr>
          <tr><td>5</td><td>Ms. Ripna</td><td>M.Com, B.Ed, UGC NET</td><td>Assistant Professor</td></tr>
          <tr><td>6</td><td>Ms. Kuldeep</td><td>—</td><td>Assistant Professor</td></tr>
          <tr><td>7</td><td>Ms. Renu</td><td>MBA</td><td>Assistant Professor</td></tr>
          <tr><td>8</td><td>Ms. Anju</td><td>M.Com, UGC NET</td><td>Assistant Professor</td></tr>
          <tr><td>9</td><td>Ms. Ishu</td><td>M.Com, B.Ed</td><td>Assistant Professor</td></tr>
        </tbody>
      </table>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Department Activities</h4>
    <h5 class="section-subtitle-orange" style="font-size:1rem;">2023–24</h5>
    <ul class="inner-lead">
      <li>Commercialisation in Various Aspects of Business (Talk)</li>
      <li>Extension Talk on Communication Skills</li>
      <li>Visit to ICAI</li>
      <li>Bank Visit</li>
      <li>Career Counselling Session</li>
      <li>Seminar on Importance of IPR</li>
    </ul>

    <h5 class="section-subtitle-orange" style="font-size:1rem;">2022–23</h5>
    <ul class="inner-lead">
      <li>Webinar on Tally</li>
      <li>PPT on Commercial Activities</li>
      <li>Health and Fitness Workshop</li>
      <li>Consumer Rights Day Celebration</li>
      <li>IPR Workshop</li>
      <li>Communication Skills Seminar</li>
    </ul>

  </div>
</div>
